module.exports = __webpack_public_path__ + "img/mail_request.934855cf.svg";